const MENU_ROLES = {
  // Tipos de usuário
  ADMIN: ['ROLE_ADMIN'],
  ANALISTA_AGNES: ['ROLE_ANALISTA_AGNES', 'ROLE_ADMIN'],
  PERFIL_ANALISTA: ['ROLE_ANALISTA_AGNES', 'ROLE_ADMIN'],

  // Menu "Saúde e segurança"
  SAUDE_SEGURANCA_AGENTES_NOCIVOS_APOSENTADORIA_ESPECIAL: [
    'ROLE_MENU_SAUDE_SEGURANCA_AGENTES_NOCIVOS_APOSENTADORIA_ESPECIAL',
    'ROLE_ADMIN',
  ],

  // Menu "Trabalhador"
  AFASTADOS_E_INATIVOS: ['ROLE_MENU_AFASTADOS_INATIVOS', 'ROLE_ADMIN'],
  CBO: ['ROLE_MENU_CBO', 'ROLE_ADMIN'],
  HORARIOS_E_JORNADA: ['ROLE_MENU_HORARIOS_JORNADA', 'ROLE_ADMIN'],

  // Menu "Folha de pagamento"
  EMPREGADORES: ['ROLE_MENU_EMPREGADORES', 'ROLE_ADMIN'],
  FOLHA_DE_PAGAMENTO: ['ROLE_MENU_FOLHA_PAGAMENTO', 'ROLE_ADMIN'],

  // Menu "Encargos"
  DCTF: ['ROLE_MENU_ENCARGOS_DCTF', 'ROLE_ADMIN'],
  DCTF_ATUALIZAR_DADOS: ['ROLE_ACTION_ATUALIZAR_DADOS_DCTF', 'ROLE_ADMIN'],
  MENSAGENS_ECAC: ['ROLE_MENU_ENCARGOS_MENSAGENS', 'ROLE_ADMIN'],
  ENCARGOS_OPORTUNIDADES: ['ROLE_MENU_ENCARGOS_OPORTUNIDADES', 'ROLE_ADMIN'],
  ENCARGOS_OPORTUNIDADES_EDITAR: ['ROLE_ENCARGOS_OPORTUNIDADES_EDITAR', 'ROLE_ADMIN'],

  // Menu "e-Gov"
  EGOV: ['ROLE_MENU_EGOV', 'ROLE_ADMIN'],
  CESSAO: ['ROLE_MENU_CESSAO', 'ROLE_ADMIN'],

  // Menu "Certidões"
  CERTIDAO_FEDERAL: ['ROLE_MENU_CERTIDAO_FEDERAL', 'ROLE_ADMIN'],
  CRF: ['ROLE_MENU_CRF', 'ROLE_ADMIN'],
  CRF_EDITAR: ['ROLE_CRF_EDITAR', 'ROLE_ADMIN'],
  CERTIDOES_ATUALIZAR_DADOS: ['ROLE_CERTIDOES_ATUALIZAR_DADOS', 'ROLE_ADMIN'],

  // Menu "Configurações"
  CENTRAL_REPROCESSAMENTO: ['ROLE_MENU_CENTRAL_REPROCESSAMENTO', 'ROLE_ADMIN'],
  IMPORTACAO: ['ROLE_IMPORTACAO', 'ROLE_ADMIN'],
  CONFIG_RUBRICAS_INCIDENCIAS_NATUREZA: ['ROLE_CONFIG_RUBRICAS_INCIDENCIAS_NATUREZA', 'ROLE_ADMIN'],
  CONFIG_RUBRICAS_CLASSIFICACAO_ANALISE: ['ROLE_CONFIG_RUBRICAS_CLASSIFICACAO_ANALISE', 'ROLE_ADMIN'],
  CONFIG_CBO_CLASSIFICACAO_ANALISE: ['ROLE_CONFIG_CBO_CLASSIFICACAO_ANALISE', 'ROLE_ADMIN'],
  CONFIG_HORARIOS_JORNADA_CLASSIFICACAO_ANALISE: [
    'ROLE_CONFIG_HORARIOS_JORNADA_CLASSIFICACAO_ANALISE',
    'ROLE_ADMIN',
  ],
};

export default MENU_ROLES;
